import { useState, useEffect, useContext } from 'react';
import _ from 'underscore';
import _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import { useWizardService } from '@bingads-webui-react/wizard';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import biddingStrategyTypes from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';

import { isSearchShoppingCampaign } from '../step-utils';

const buildSchemaData = ({
  data, timeDisplayType, isAudienceShoppingCampaign, serverContext,
}) => {
  // For AWF, some targets have to be created at ad group level
  const targetParentEntity = isAudienceShoppingCampaign ? data.adGroup : data.campaign;
  const locations = _.map(
    _.filter(
      _.get(targetParentEntity, ['locationTargets', 'currentLevelSettings', 'currentLocations'], []),
      loc => loc.SelectionStatus === 'Included'
    ),
    loc => loc.location
  );
  const autoBidding = [biddingStrategyTypes.maximizeConversions, biddingStrategyTypes.maximizeClicks, biddingStrategyTypes.maxConversionValue, biddingStrategyTypes.targetRoas, biddingStrategyTypes.costPerSale];

  return ({
    campaignName: {
      data: data.campaign.Name,
    },
    conversionGoals: {
      conversionGoals: data.campaign.conversionGoals,
    },
    store: {
      storeName: data.campaign.StoreName,
    },
    feeds: {
      feedLabel: data.campaign.FeedLabel,
      isRendered: !_.isEmpty(data.campaign.FeedLabel),
    },
    localInventory: {
      isLocalInventoryEnabled: data.campaign.LocalInventoryAdsEnabled,
      isRendered: !isAudienceShoppingCampaign,
    },
    productCollections: {
      isProductCollectionsEnabled: data.campaign.ShoppableAdsEnabled,
      isRendered: !isAudienceShoppingCampaign,
    },
    products: {
      productFilters: data.campaign.ProductFilters,
      useSelectedItem: true,
    },
    adGroupName: {
      data: data.adGroup.Name,
    },
    locationTargeting: {
      locations,
      targetOption: _.get(targetParentEntity, ['locationTargets', 'currentLevelSettings', 'targetOption'], null),
    },
    genderTargeting: {
      genders: targetParentEntity.genderTypes,
      isRendered: isAudienceShoppingCampaign,
    },
    ageRangeTargeting: {
      ageRanges: targetParentEntity.ageRanges,
      isRendered: isAudienceShoppingCampaign,
    },
    // PT is hidden until backend algo is ready
    // predictiveTargeting: {
    //   isPredictiveTargetingEnabled: data.adGroup.UseOptimizedTargeting,
    //   isRendered: isAudienceShoppingCampaign,
    // },
    advancedTargetingSeparator: {},
    startEndDates: {
      startDate: data.adGroup.StartDate,
      endDate: data.adGroup.EndDate,
    },
    adSchedule: {
      adSchedules: data.campaign.adSchedules && data.campaign.adSchedules.dayTimeRanges,
      useSearcherTimeZone: data.campaign.AdScheduleUseSearcherTimeZone,
      timeDisplayType,
      includeStartEnd: false,
      isRendered: !_.isEmpty(data.campaign.adSchedules),
    },
    adDistribution: {
      adDistribution: data.adGroup.AdDistribution,
      isRendered: !isAudienceShoppingCampaign,
    },
    budget: {
      data: data.campaign.Budget,
      currencyCode: serverContext.CurrentAccount.CurrencyCode,
    },
    bidStrategy: {
      data: data.campaign.BiddingScheme,
    },
    bidValue: {
      data: data.adGroup.SearchBid,
      currencyCode: serverContext.CurrentAccount.CurrencyCode,
      isRendered: data.campaign.BiddingScheme && !_.contains(autoBidding, data.campaign.BiddingScheme.Type),
    },
  });
};

export const useSummarySchemaData = ({ data }) => {
  const { state } = useWizardService();
  const { flow } = state.context.wizardData;
  const isAudienceShoppingCampaign = !isSearchShoppingCampaign(flow);

  const [timeDisplayType, setTimeDisplayType] = useState('12-hour');

  const serverContext = useContext(ServerContext);

  useEffect(() => {
    const preferencesService = _preferencesService.default || _preferencesService;
    preferencesService.initialize().then(() => {
      const isTwelveHourDisplay = preferencesService.findByName('WebApp.CampaignUI.isTwelveHourDisplay') || {};
      setTimeDisplayType(_.isUndefined(isTwelveHourDisplay.Data) || isTwelveHourDisplay.Data ? '12-hour' : '24-hour');
    });
  }, []);

  return (data && buildSchemaData({
    data, timeDisplayType, isAudienceShoppingCampaign, serverContext,
  })) || {};
};

